import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetBugReportIssueComments} from '../services/bugReporter.http'

export const useGetBugReportIssueComments = (issueId: string, {enabled}: {enabled: boolean}) =>
    useQuery({
        queryKey: [QUERY_KEYS.BUG_REPORTER_ISSUE_COMMENTS, issueId],
        queryFn: () => httpGetBugReportIssueComments(issueId),
        enabled
    })
